<div *ngIf="!subformulas" class="p-grid p-fluid">
  <h6>FÓRMULA # {{ formula?.pk.id }}</h6>
  <formula-child [formulaChild]="formula" [tipo]="" class="p-col-12 p-md-10">
  </formula-child>
</div>

<div *ngIf="subformulas" class="p-grid p-fluid">
  <formula-child *ngFor="let sub of subformulas" [formulaChild]="sub.formula" [tipo]="sub.tipo"
    class="p-col-12 p-md-10">
  </formula-child>
</div>